import styled from 'styled-components';
import { Upload as AntUpload } from "antd";
import { theme } from '@theme';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  width: 100%;
  margin-top: 32px;
  padding: 60px 80px 30px 80px;
  overflow-y: hidden;

  &.nested {
    margin-top: 0;
    flex-direction: row;
  }

  @media screen and (max-width: ${theme.breakpoints.md}) {
    padding: 60px 16px 30px 16px;
    flex-direction: column;
  }

  @media screen and (max-width: ${theme.breakpoints.sm}) {
    flex-direction: column-reverse;
    height: fit-content;

    &.nested {
      flex-direction: column-reverse;
  }
  }
`

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  &.nested {
    margin-top: 0;
    flex-direction: row;
  }

  @media screen and (max-width: ${theme.breakpoints.md}) {
    flex-direction: column;
  }
  @media screen and (max-width: ${theme.breakpoints.sm}) {
    flex-direction: column-reverse;
    height: fit-content;

    &.nested {
      flex-direction: column-reverse;
    }
  }
`

export const ProfileWrapper = styled.div`
  height: fit-content;
  background: #F9F2EC;
  padding: 24px;
  border-radius: 8px;
  width: 100%;
  max-width: 690px;

  @media screen and (max-width: ${theme.breakpoints.md}) {
    max-width: none;
  }
  
  .title {
    @media screen and (max-width: ${theme.breakpoints.sm}) {
      text-align: center !important;
    }
  }
`

export const Parent = styled.div`
  display: flex;
  margin: 24px 0;
  gap: 50px;
  
  @media screen and (max-width: ${theme.breakpoints.xlg}) {
    gap: 25px;
  }

  @media screen and (max-width: ${theme.breakpoints.sm}) {
    flex-direction: column;
  }

  & > form > .date-select > div {
    @media screen and (max-width: ${theme.breakpoints.sm}) {
      width: 100%;
      flex-direction: row !important;
    }
  }
`

export const Upload = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 18px;
  cursor: pointer;
`

export const UploadParent = styled(AntUpload)`
  .ant-upload-list-text {
    display: none !important;
  }

  @media screen and (max-width: ${theme.breakpoints.sm}) {
    display: flex;
    justify-content: center;
  }
`

export const DividerVertical = styled.div`
  width: 1px;
  background: rgba(209, 201, 193, 0.5);
`

export const Actions = styled.div`
  display: flex;
  justify-content: end;
  gap: 6px;

  @media screen and (max-width: ${theme.breakpoints.sm}) {
    justify-content: center;
  }
`

export const SelectWrapper = styled.div`
  display: flex;
  gap: 6px;

  & > div > div {
    @media screen and (max-width: ${theme.breakpoints.xlg}) {
      width: 80px !important;
    }
    
    @media screen and (max-width: ${theme.breakpoints.sm}) {
      width: 100% !important;
    }
  }

  @media screen and (max-width: ${theme.breakpoints.sm}) {
    flex-direction: column;
  }
`

export const Notifications = styled.div`
  margin-top: 16px;
  padding: 24px;
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100% - 48px);
`

export const EnergyWrapper = styled.div`
  padding: 24px;
  background: #F9F2EC;
  border-radius: 8px;
  max-width: 450px;
  width: 100%;
  height: 106px;

  @media screen and (max-width: ${theme.breakpoints.md}) {
    max-width: none;
  }
`

export const Candle = styled.div`
  display: flex;
  align-items: center;
  padding: 2px;
  border-radius: 999px;
  gap: 6px;
  color: #4F473A;

  span {
    color: rgba(79, 71, 58, 0.4);
    margin-right: 10px;
  }
`

export const Energy = styled.div<{full?: boolean}>`
  height: 4px;
  background: ${({full}) => full && "#C6A691"};
  border: ${({full}) => !full && "1px solid #C6A691"};
  border-radius: 999px;
`
